<template>
  <div class="apply-container">
    <div class="title-container">
      <div class="title">{{languages.softwareApply.apply}}:</div>
    </div>
    <div class="form-container">
      <el-form ref="addFormRef"
               inline
               :model="applyForm"
               :rules="$rules.softwareApply">
        <el-row>
          <el-col :offset="2"
                  :span="10">
            <el-form-item :label-width="titleWidth"
                          required
                          prop="softwareName">
              <span slot="label">{{languages.softwareApply.software}}:</span>
              <el-input v-model="applyForm.softwareName"
                        size="small"
                        placeholder=""
                        :disabled="applyLoading"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label-width="titleWidth"
                          required
                          prop="companyName">
              <span slot="label">{{languages.softwareApply.site}}:</span>
              <el-select v-model="applyForm.companyName"
                         size="small"
                         placeholder=""
                         @change="siteChange"
                         :disabled="applyLoading"
                         clearable>
                <el-option :label="item.city"
                           :value="item.city"
                           v-for="item in siteList"
                           :key="item.city"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :offset="2"
                  :span="10">
            <el-form-item :label-width="titleWidth"
                          prop="phone">
              <span slot="label">{{languages.softwareApply.contact}}:</span>
              <el-input v-model="applyForm.phone"
                        size="small"
                        placeholder=""
                        :disabled="applyLoading"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label-width="titleWidth"
                          required
                          prop="location">
              <span slot="label">{{languages.softwareApply.location}}:</span>
              <el-select v-model="applyForm.location"
                         size="small"
                         placeholder=""
                         :disabled="applyForm.companyName==='' || applyLoading"
                         clearable>
                <el-option :label="item"
                           :value="item"
                           v-for="item in locationList"
                           :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :offset="2"
                  :span="10">
            <el-form-item :label-width="titleWidth"
                          required
                          prop="seat">
              <span slot="label">{{languages.softwareApply.seat}}:</span>
              <el-input v-model="applyForm.seat"
                        size="small"
                        placeholder=""
                        :disabled="applyLoading"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label-width="titleWidth"
                          required
                          prop="deskCode">
              <span slot="label">{{languages.softwareApply.pcCode}}:</span>
              <el-input v-model="applyForm.deskCode"
                        size="small"
                        placeholder=""
                        :disabled="applyLoading"
                        clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="3"
                :offset="5">
          <div v-if="isConfirming"
               class="confirm-container">
            <el-button class="cancel-button"
                       :disabled="applyLoading"
                       @click="onCancel">{{languages.softwareApply.cancel}}</el-button>
            <el-button class="confirm-button"
                       :loading="applyLoading"
                       @click="onSubmit">{{languages.softwareApply.confirm}}</el-button>
          </div>
          <el-button v-if="!isConfirming"
                     class="apply-button"
                     @click="toSubmit">{{languages.softwareApply.submitInc}}</el-button>
        </el-col>
        <el-col :span="3"
                :offset="5">
          <el-button class="apply-button"
                     :loading="isSaving"
                     :disabled="applyLoading"
                     @click="onSave">{{languages.softwareApply.saveDraft}}</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="inc-container">
      <div class="inc-filter">
        <div class="filter-title">{{languages.softwareApply.filter}}:</div>
        <div v-bind:class="checkedFilter===1?'btn-checked':'btn-unchecked'"
             @click="incQuery(1)">
          <i class="el-icon-loading"
             v-if="checkedFilter===1 && weekLoading"></i>
          {{languages.softwareApply.week}}
        </div>
        <div v-bind:class="checkedFilter===4?'btn-checked':'btn-unchecked'"
             @click="incQuery(4)">
          <i v-if="checkedFilter===4 && weekLoading"
             class="el-icon-loading"></i>
          {{languages.softwareApply.month}}
        </div>
        <div v-bind:class="checkedFilter===26?'btn-checked':'btn-unchecked'"
             @click="incQuery(26)">
          <i class="el-icon-loading"
             v-if="checkedFilter===26 && weekLoading"></i>
          {{languages.softwareApply.halfYear}}
        </div>
        <div v-bind:class="checkedFilter===52?'btn-checked':'btn-unchecked'"
             @click="incQuery(52)">
          <i class="el-icon-loading"
             v-if="checkedFilter===52 && weekLoading"></i>
          {{languages.softwareApply.year}}
        </div>
      </div>
    </div>
    <div class="inc-list">
      <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',padding:'5px 0',
      textAlign: 'center'}"
                :cell-style="{padding:'5px 0'}"
                style="width: 100%"
                header-align="center"
                :height="'100%'"
                :data="incList"
                :row-key="getRowKeys"
                :expand-row-keys="expands"
                @expand-change="expandSelect"
                :empty-text='languages.softwareApply.noIncs'>
        <el-table-column type="expand"
                         width="25px">
          <template slot-scope="props">
            <div class="expand-container">
              <!-- <div class="expand-list">
                <div class="expand-title">{{languages.softwareApply.details}}:</div>
                <div class="expand-desc">{{props.row.incSymptom.replace('\r\n\r\n','')}}</div>
              </div> -->
              <div class="expand-list">
                <div class="expand-title">{{languages.softwareApply.handler}}:</div>
                <div class="expand-desc">
                  {{props.row.assignee===''?languages.softwareApply.assigned:props.row.assignee}}
                </div>
              </div>
              <div class="expand-list">
                <div class="expand-title">{{languages.softwareApply.targetTime}}:</div>
                <div class="expand-desc">{{props.row.incTargetTime}}</div>
              </div>
              <div class="expand-list">
                <div class="expand-title">{{languages.softwareApply.solution}}:</div>
                <div class="expand-desc">{{solveResolution(props.row.resolution)}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="languages.softwareApply.ticket"
                         align="center"
                         width="150px"
                         prop="incId">
        </el-table-column>
        <el-table-column :label="languages.softwareApply.software"
                         align="center"
                         prop="incSymptom">
          <template slot-scope="scope">
            {{getSoftName(scope.row.incSymptom)}}
          </template>
        </el-table-column>
        <el-table-column :label="languages.softwareApply.status"
                         align="center"
                         width="90px">
          <template slot-scope="scope">
            {{languages.softwareApply[scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column :label="languages.softwareApply.createTime"
                         align="center"
                         width="140px"
                         prop="createDate">
        </el-table-column>
        <el-table-column :label="languages.softwareApply.edit"
                         min-width="100px">
          <template slot-scope="scope">
            <div class="edit-button"
                 v-if="scope.row.status!=='Closed'"
                 v-bind:class="submitType===''?'':'hidden'">
              <el-button type="primary"
                         size="mini"
                         :disabled='cancelReminding'
                         @click="toConfirm('revoke',scope.row.incId)">
                {{languages.softwareApply.cancelInc}}
              </el-button>
              <el-button type="warning"
                         size="mini"
                         :disabled='cancelReminding'
                         @click="toConfirm('reminder',scope.row.incId)">
                {{languages.softwareApply.remind}}
              </el-button>
            </div>
            <div class="edit-button"
                 v-bind:class="submitType==='' || scope.row.incId!==submitId?'hidden':''">
              <el-button size="mini"
                         :disabled='incLoading'
                         @click="cancelInc()">
                {{languages.softwareApply.cancel}}
              </el-button>
              <el-button type="primary"
                         size="mini"
                         :loading="incLoading"
                         @click="submitInc(scope.row)">
                {{languages.softwareApply.confirm}}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="count-container">{{languages.softInstall.total}}: {{count}}</div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  data () {
    return {
      expands: [],
      count: 0,
      isConfirming: false,
      applyLoading: false,
      incLoading: false,
      weekLoading: false,
      isSaving: false,
      checkedFilter: 1,
      titleWidth: '110px',
      applyForm: {
        lan: '',
        seat: '',
        companyName: '',
        phone: '',
        location: '',
        softwareName: '',
        deskCode: '',
      },
      siteList: [],
      locationList: [],
      userBaseInfo: '',
      incList: [],
      submitType: '',
      submitId: '',
      cancelReminding: false,
    };
  },
  computed: {
    ...mapState([
      'languages',
    ]),
  },
  methods: {
    ...mapMutations([
      'setPageNow',
      'setErrorTips',
      'setErrorType',
      'setHomeHidden',
      'setSearchHidden',
      'setShowFooter',
    ]),
    ...mapActions([
      'softApply',
      'saveLog',
    ]),
    getRowKeys (row) {
      return row.incId;
    },
    expandSelect (row, expandedRows) {
      console.log(row, expandedRows);
      this.expands = [];
      if (expandedRows.length > 0 && row) {
        this.expands.push(row.incId);
      }
    },
    solveResolution (data) {
      return data.substr(0, data.length - 1);
    },
    getSoftName (data) {
      const descList = data.split('\r\n');
      let desc = '';
      desc = descList.filter((item) => item.indexOf('软件名称') !== -1 || item.indexOf('software') !== -1);
      if (desc.length === 1) return desc[0].replace('软件名称 : ', '').replace('software : ', '');
      return '';
    },
    incQuery (id) {
      if (this.incLoading) return;
      this.checkedFilter = id;
      this.queryIncDatas(id);
    },
    siteChange () {
      if (this.applyForm.companyName === '') {
        this.applyForm.location = '';
        return;
      }
      const list = this.siteList.filter((item) => (item.city === this.applyForm.companyName));
      if (list.length === 1) this.locationList = list[0].location;
    },
    async queryCityDatas () {
      const cityList = await this.softApply({ type: 'cityinfo' });
      console.log('cityList', cityList);
      if (cityList.status === 'failed') {
        this.setErrorTips('SoftwareApply > getCityInfo failed');
        this.saveLog({
          title: 'api_error',
          lan: this.languages.lan,
          target: 'SoftwareApply > getCityInfo',
          description: cityList.data,
        });
        this.setErrorType('apierror');
        this.$router.push('/error');
        return;
      }
      this.siteList = cityList.data;
    },
    async queryUserInfos (method) {
      const userBaseInfo = await this.softApply({ type: 'baseinfo' });
      // userBaseInfo.data.companyname = 'test area';
      console.log('userBaseInfo', userBaseInfo);
      if (userBaseInfo.status === 'success') this.userBaseInfo = userBaseInfo.data;
      method();
    },
    setDraftDatas (datas) {
      const draftForm = JSON.parse(datas);
      this.applyForm = { ...draftForm };
      const list = this.siteList.filter((item) => (item.city === draftForm.companyName));
      if (list.length === 1) {
        this.locationList = list[0].location;
      }
    },
    setUserDatas () {
      this.applyForm.seat = this.userBaseInfo.seat;
      this.applyForm.phone = this.userBaseInfo.phone;
      this.applyForm.deskCode = this.userBaseInfo.lastpc;
      const list = this.siteList.filter(
        (item) => (item.city === this.userBaseInfo.companyname),
      );
      console.log('setUserData', list);
      if (list.length === 1) {
        this.applyForm.companyName = this.userBaseInfo.companyname;
        this.locationList = list[0].location;
      }
    },
    toSubmit () {
      console.log(this.applyForm);
      this.applyForm.lan = this.languages.lan;
      if (this.applyForm.phone.length > 8) {
        this.$message.warning(this.languages.softwareApply.extWarn);
        return;
      }
      this.$refs.addFormRef.validate(async (valid) => {
        if (valid) {
          this.isConfirming = true;
        }
      });
    },
    toConfirm (type, id) {
      this.submitType = type;
      this.submitId = id;
      this.cancelReminding = true;
    },
    cancelInc () {
      this.submitType = '';
      this.submitId = '';
      this.cancelReminding = false;
    },
    async submitInc (inc) {
      console.log('inc', this.submitType, inc);
      this.cancelReminding = true;
      this.incLoading = true;
      const { incId } = inc;
      const submitter = this.userBaseInfo.empcode;
      const { lan } = this.languages;
      const data = { incId, submitter, lan };
      const type = this.submitType;
      const result = await this.softApply({ type, data });
      console.log('submitInc', result, data);
      if (result.status === 'success') {
        this.$message.success(this.languages.softwareApply.success);
      } else {
        this.$message.warning({ message: result.data, duration: 5000 });
      }
      this.incLoading = false;
      this.submitType = '';
      this.submitId = '';
      this.cancelReminding = false;
      this.queryIncDatas(this.checkedFilter);
    },
    onCancel () {
      this.isConfirming = false;
    },
    onSave () {
      this.isSaving = true;
      setTimeout(() => {
        const draftData = JSON.stringify(this.applyForm);
        window.localStorage.setItem('apply_draft', draftData);
        this.isSaving = false;
      }, 300);
    },
    async onSubmit () {
      this.applyLoading = true;
      const result = await this.softApply({ type: 'add', data: this.applyForm });
      console.log('result >>> ', result);
      if (result.status === 'success') {
        this.$message.success(this.languages.softwareApply.success);
        this.saveLog({
          title: 'SoftwareApply',
          lan: this.languages.lan,
          softwareName: this.applyForm.softwareName,
          target: 'Submit Application',
          description: 'Success',
        });
        this.applyForm.softwareName = '';
        this.queryIncDatas(1);
        window.localStorage.removeItem('apply_draft');
      } else {
        this.setErrorTips('SoftwareApply > Submit Application failed');
        this.saveLog({
          title: 'SoftwareApply',
          lan: this.languages.lan,
          softwareName: this.applyForm.softwareName,
          target: 'Submit Application',
          description: 'Failed',
        });
        this.$message.warning(this.languages.softwareApply.fail);
      }
      this.applyLoading = false;
      this.isConfirming = false;
    },
    queryDatas () {
      this.queryCityDatas();
      this.queryUserInfos(() => {
        const draftDatas = window.localStorage.getItem('apply_draft');
        if (draftDatas) {
          this.setDraftDatas(draftDatas);
        } else {
          this.setUserDatas();
        }
      });
    },
    async queryIncDatas (week) {
      this.weekLoading = true;
      const result = await this.softApply({ type: 'queryinc', data: week });
      console.log('queryIncDatas', result);
      if (result.status === 'success') {
        this.incList = result.data;
        this.count = this.incList.length;
      }
      this.weekLoading = false;
    },
  },

  created () {
    this.setPageNow('SoftwareApply');
    this.setHomeHidden(false);
    this.setSearchHidden(true);
    this.setShowFooter(false);
    this.queryDatas();
    this.queryIncDatas(1);
  },
};
</script>

<style lang="scss" scoped>
.title-container {
  height: 40px;
  border-bottom: 1px solid #ebeced;
  margin: 0 30px 0 24px;
  .title {
    position: relative;
    top: 14px;
    font-size: 16px;
    line-height: 16px;
  }
}
.form-container {
  margin-top: 13px;
  // width: 830px;
  .el-col {
    margin-bottom: -22px;
  }
  .apply-button {
    width: 240px;
    height: 36px;
    background-color: #1466de;
    color: #ffffff;
    margin-top: 10px;
  }
  .confirm-container {
    // border: 1px solid #000;
    width: 240px;
    display: flex;
    margin-top: 10px;
    .cancel-button,
    .confirm-button {
      width: 120px;
      height: 36px;
    }
    .cancel-button {
      color: #1466de;
      border: 1px solid #1466de;
    }
    .confirm-button {
      background-color: #1466de;
      color: #ffffff;
    }
  }
}
.inc-container {
  margin-top: 40px;
  .inc-filter {
    margin-left: 24px;
    font-size: 15px;
    display: flex;
    .filter-title {
      width: 64px;
      height: 29px;
      line-height: 29px;
      text-align: right;
      font-size: 14px;
    }
    .btn-checked,
    .btn-unchecked {
      text-align: center;
      font-size: 12px;
      border-radius: 3px;
      margin-left: 16px;
      cursor: pointer;
    }
    .btn-checked {
      width: 74px;
      height: 29px;
      line-height: 29px;
      background-color: #1466de;
      color: #fff;
    }
    .btn-unchecked {
      width: 72px;
      height: 27px;
      line-height: 27px;
      color: #1466de;
      border: 1px solid #1466de;
    }
  }
}
.inc-list {
  overflow: hidden;
  position: absolute;
  top: 354px;
  bottom: 25px;
  left: 20px;
  right: 20px;
}
.count-container {
  position: absolute;
  right: 30px;
  top: 317px;
  font-size: 14px;
}
.edit-button {
  display: flex;
  // margin: 1px;
}
.expand-container {
  margin: -10px;
  display: flex;
  flex-direction: column;
  align-items: left;
  .expand-list {
    display: flex;
    line-height: 20px;
    .expand-title {
      margin-left: -20px;
      font-weight: 700;
      width: 110px;
      text-align: right;
    }
    .expand-desc {
      margin-left: 10px;
      white-space: pre-line;
    }
  }
}
.hidden {
  display: none;
}
</style>
